<template>
  <div v-if="item">
    <div class="
                                                  grid grid-cols-[repeat(2,auto)] grid-rows-[repeat(3,auto)]
                                                  gap-2
                                                  justify-start justify-items-start
                                                  items-center
                                                ">
      <div class="row-span-3 cursor-pointer relative" @click="goProduct">
        <img :src="$firstImage(item.images, 'small')" alt="" class="img h-7rem w-7rem object-cover"
          :onerror="defaultUrl" />
        <div class="status absolute z-10 inset-0 " v-if="item.status != 10 || !item.stock">
          <span class="iconfont icon-yishouqing" v-if="!item.stock"></span>

          <span class=" iconfont icon-yixiajia" v-else></span>

        </div>
      </div>
      <p class="text-1.1rem font-bold cursor-pointer" @click="goProduct">
        {{ item.name }}
      </p>
      <p class="space-x-3 text-gray-600">
        <span>{{ item.attribute_text }}</span>
      </p>
      <p class="space-x-3 text-gray-400 text-sm">
        <span>{{ $t('库存')}}：{{ item.stock }}</span>
      </p>
      <p class="space-x-3"></p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-dom";

export default defineComponent({
  props: { item: Object },
  setup(props, ctx) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';
    const goProduct = () => {
      ctx.root.$router.push({
        name: "ProductDetail",
        params: { id: props.item.id },
      });
    };
    return { goProduct, defaultUrl };
  },
});
</script>

<style scoped lang="scss">
.status {
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  @apply flex justify-center items-center;

  .iconfont {
    font-size: 4rem;
  }
}
</style>
